export default __webpack_public_path__ + "media/collab_opportunity2_icon.61dfb6238a584cba1ff08e10a5a570ae.svg";